import { auth, database } from "../../../services/firebase-config";
import { doc, getDoc } from "firebase/firestore";
import { signOut } from "firebase/auth"
import { useNavigate } from "react-router-dom"
import { useEffect } from "react";

export default function VerifyLogin({ children }) {
  const navigate = useNavigate();

  async function verifyUser() {
    try {
      const docRef = await doc(database, 'users', auth.currentUser.uid)
      const document = await getDoc(docRef);
      if (document.data().admin) {
        return (true);
      }
      else {
        await signOut(auth);
        navigate('/login', { replace: true })
        return (false);
      }
    }
    catch (error) {
      navigate('/login', { replace: true })
      console.log(error);
    }
  }

  useEffect(() => {
    verifyUser();
  }, []);



  return (<>{children}</>);
}